import React, { createElement, useState } from "react";
import { FileDown, Loader2 } from "lucide-react";
import { countryTransfertService } from "../../../services/countryTransfertService";
import { alertError } from "../../../helpers/alertError";

const pad = (n: number) => String(n).padStart(2, "0");

/**
 * Bouton "Télécharger le PDF des taux".
 * Au clic : récupère les taux à jour, génère le tableau quotidien (format du modèle Excel) et lance le téléchargement.
 * @react-pdf/renderer est chargé à la demande pour ne pas alourdir le bundle principal.
 */
const DownloadRatesPdfButton: React.FC<{ className?: string }> = ({ className = "" }) => {
  const [loading, setLoading] = useState(false);

  const handleDownload = async () => {
    setLoading(true);
    try {
      const [rates, { pdf }, { default: DailyRatesPdfDocument }] = await Promise.all([
        countryTransfertService.getCountryTransferts(500, 0),
        import("@react-pdf/renderer"),
        import("./DailyRatesPdfDocument"),
      ]);

      const now = new Date();
      const doc = createElement(DailyRatesPdfDocument, { rates: rates || [], generatedAt: now });
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const blob = await pdf(doc as any).toBlob();

      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `TABLEAU QUOTIDIEN DES TAUX - ${pad(now.getDate())}-${pad(now.getMonth() + 1)}-${now.getFullYear()}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      setTimeout(() => URL.revokeObjectURL(url), 1000);
    } catch (error) {
      console.error(error);
      alertError("Impossible de générer le PDF des taux.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      type="button"
      onClick={handleDownload}
      disabled={loading}
      className={`bg-white border border-gray-300 text-gray-700 px-4 py-2 rounded-lg hover:bg-gray-50 transition-colors flex items-center gap-2 disabled:opacity-60 ${className}`}
    >
      {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <FileDown className="w-4 h-4" />}
      <span>{loading ? "Génération..." : "Télécharger le PDF des taux"}</span>
    </button>
  );
};

export default DownloadRatesPdfButton;
